(ns dre.pages.views
  (:require
   [dre.app.events :as-alias app]
   [dre.components.banners :refer [banners platform-migration-banner]]
   [dre.components.error-view :refer [error-view]]
   [dre.components.platform-toolbar.views :as platform-toolbar]
   [dre.config :as-alias conf]
   [dre.i18n.views :refer [tr]]
   [dre.modals.surveys.events :as-alias e-surveys]
   [dre.pages.db :as db]
   [dre.pages.events :as-alias pages]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def component-name :page)

(defn loading
  [state]
  [:div#litsearch-loader
   [:svg [:use {:href "#litsearch-logo"}]]
   [:p
    (case state
      :checking-auth
      [tr "Checking your authentication."]

      :redirecting-to-sso
      [tr "Session expired, redirecting to sign-in page."]

      :failure
      [tr "Authentication failed."]

      nil)]])


(defn base-page
  []
  (let [page-id (rf/subscribe [::pages/current-page-id])
        scroll-pos (rf/subscribe [::pages/scroll-pos])
        error (r/atom nil)]
    (r/create-class
      {:display-name "base-page"

       :component-did-update
       (fn []
         (js/setTimeout #(.scrollTo js/window 0 @scroll-pos) 50))

       :component-did-catch
       (fn [_this e _info]
         (js/console.log e))  ; TODO: Notify Sentry

       :get-derived-state-from-error
       (fn [e]
         (reset! error e)
         #js {})

       :reagent-render
       (fn [] 
         (if-let [id @page-id]
           (if (= id :not-found)
             [(get-in db/index [:not-found :view])]
             (do
               (rf/dispatch [::e-surveys/show])
               [:section
                {:class (bem/bm component-name id)}
                (if-let [err @error]
                  [error-view (str err)]
                  [:<>
                   [platform-migration-banner]
                   [banners]
                   [:div {:class [(bem/be component-name :toolbar)
                                  (when-not (= id :frontpage) (bem/bem component-name :toolbar :common))]}
                    [platform-toolbar/view id]]
                   [:div {:class (bem/be component-name :content)}
                    [(get-in db/index [id :view])]]])]))
           [loading]))})))


(defn view
  "Base component for all pages"
  []
  (let [state @(rf/subscribe [::app/status])]
    (case state
      :success [base-page]
      [loading state])))
